"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M354.2 104.2H83.3c-23 0-41.7 18.7-41.7 41.7v164.6c0 23 18.7 41.7 41.7 41.7h155.4c-6.4-15.9-9.6-32.9-9.6-50 0-74.8 60.6-135.4 135.4-135.4 10.5 0 21 1.2 31.2 3.8V146c.1-23.2-18.5-41.8-41.5-41.8zM93.7 166.7c-5.8 0-10.4-4.7-10.4-10.4s4.7-10.4 10.4-10.4c5.8 0 10.4 4.7 10.4 10.4s-4.6 10.4-10.4 10.4zm41.7 0c-5.8 0-10.4-4.7-10.4-10.4s4.7-10.4 10.4-10.4c5.8 0 10.4 4.7 10.4 10.4s-4.6 10.4-10.4 10.4zm41.7 0c-5.8 0-10.4-4.7-10.4-10.4s4.7-10.4 10.4-10.4 10.4 4.7 10.4 10.4-4.7 10.4-10.4 10.4z"
  }), (0, _core.jsx)("path", {
    d: "M364.6 208.3c-51.8 0-93.8 42-93.8 93.8s42 93.8 93.8 93.8 93.8-42 93.8-93.8c.1-51.7-41.7-93.6-93.3-93.8h-.5zM404 341.5c-1.8 1.8-4.2 2.8-6.7 2.7-2.5 0-4.9-1-6.7-2.7L355.2 306v-60.2c0-5.2 4.2-9.4 9.4-9.4s9.4 4.2 9.4 9.4v52.3l30 30c3.5 3.8 3.5 9.6 0 13.4z"
  }));
};

exports.default = _default;